import { useQuery } from '@tanstack/react-query';

import { getUrlParamsFetch } from '@/shared';
import { erpApi } from '@/shared/axios/erp-api';
import { UserProfileSoporteKeysEnum, urlBackend } from '@/shared/constants';
import {
  UserProfile,
  UserProfilesPagingRes,
} from '@/shared/interfaces/erp/administration/user-profile.interface';
import { useUiStore } from '@/store/ui';

const { get } = erpApi();

// type UpdateUserProfileParams = {
//   id: number;
//   data: GrupoSistemaPOST;
// };


///* tanSctack query
export const useFetchUserProfiles = (params?: GetUserProfilesParams) => {
  return useQuery({
    queryKey: ['adminUserProfiles', ...Object.values(params || {})],
    queryFn: async () => {
      return getUserProfiles(params);
    },
  });
};

export const useGetUserProfile = (id: string) => {
  return useQuery({
    queryKey: ['adminUserProfiles', id],
    queryFn: async () => {
      return getUserProfile(id);
    },
  });
};

// export const useUpdateSystemGroupPermissions = ({
//   navigate,

//   enableRedirect = true,
//   returnUrl,

//   returnErrorUrl,
//   enableErrorRedirect = false,
//   customMessageErrorAlert,

//   enableSuccessAlert = true,
//   customSuccessMessage,
// }: UseMutationsParams) => {
//   const queryClient = useQueryClient();
//   const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
//   const setAlert = useUiStore.getState().setAlert;

//   return useMutation({
//     mutationFn: updateSystemGroupPermissions,
//     onSuccess: () => {
//       queryClient.invalidateQueries({ queryKey: ['grupo-sistemas'] });

//       enableRedirect && navigate && returnUrl && navigate(returnUrl);

//       enableSuccessAlert &&
//         setAlert &&
//         setAlert(
//           true,
//           customSuccessMessage ?? 'Grupo de Sistema actualizado correctamente',
//           AlertSeverityEnum.success
//         );
//     },
//     onError: error => {
//       enableErrorRedirect &&
//         navigate &&
//         returnUrl &&
//         navigate(returnErrorUrl ?? (returnUrl || ''));

//       handleAxiosError(error, customMessageErrorAlert);
//     },
//     onSettled: () => {
//       setIsGlobalLoading(false);
//     },
//   });
// };






///* axios
export type GetUserProfilesParams = {
  page?: number;
  page_size?: number;
  identificacion?: string;
  nombre?: string;
  apellido?: string;

  ///* fk
  empresa?: number;
  sucursal?: number;
  area?: string;

  /// to get user in flota
  departamento?: string;
  cargo?: string;
  // fetch data only when departamento and cargo are not null
  departamentoAndCargo?: {
    departamento: string;
    cargo: string;
  };
};

export type CreateUserProfilesParams = Omit<UserProfile, 'id'>;
export type UpdateUserProfilesParams = {
  id: string;
  data: UserProfile;
};

export const getUserProfiles = async (params?: GetUserProfilesParams) => {
  let {
    page = 1,
    page_size = 10,
    identificacion = '',
    nombre = '',
    apellido = '',
    empresa = 0,
    sucursal = 0,
    area = '',
    departamento = '',
    cargo = '',
    departamentoAndCargo,
  } = params || {};
  if (departamentoAndCargo?.departamento) {
    departamento = departamentoAndCargo.departamento;
  }
  if (departamentoAndCargo?.cargo) {
    cargo = departamentoAndCargo.cargo;
  }

  return get<UserProfilesPagingRes>(
    `${urlBackend}api/v1/user-profiles/?page=${page}&page_size=${page_size}&identificacion=${identificacion}&nombre=${nombre}&apellido=${apellido}&empresa=${empresa}&sucursal=${sucursal}&area=${area}&departamento=${departamento}&cargo=${cargo}`,
    true
  );
};

export const getUserProfile = async (id: string) => {
  const setAlert = useUiStore.getState().setAlert;
  const res = await get<UserProfile>(
    `${urlBackend}api/v1/user-profiles/${id}/`,
    true
  );

  res.status === 'error' && setAlert(true, res.message, res.status);
  return res;
};

////* fetch user profile ----------------
type GetAllUserProfilesParams = {
  page?: number;
  page_size?: number;

  // filters
  identificacion?: string; // cedula
  nombre?: string;
  apellido?: string;
  nombre_completo?: string;

  ////* fk
  user?: number;
  rol?: string;
  tipo_documento?: string;
  empresa?: number;
  sucucursal?: number;
  area?: string;
  // to get user in flota (fk)
  departamento?: string;
  cargo?: string;

  // login info
  last_login_ip?: null;
  last_login_date?: null;

  intentos_fallidos?: number;
  fecha_bloqueo?: string;
  fecha_ultimo_cambio_clave?: string;
  is_active?: boolean; // block or unblock incorrect password

  fecha_creacion?: string;
  fecha_modificacion?: string;

  // filter by state like soft delete
  filterByState?: boolean;
};

export const useGetAllUserProfiles = (params?: GetAllUserProfilesParams) => {
  return useQuery({
    queryKey: [
      UserProfileSoporteKeysEnum.USERS_PROFILE_ALL,
      ...Object.values(params || {}),
    ],
    queryFn: async () => {
      return getAllUserProfiles(params);
    },
  });
};

export const getAllUserProfiles = async (params?: GetAllUserProfilesParams) => {
  const queryParams = getUrlParamsFetch(params || {});

  return get<UserProfilesPagingRes>(
    `${urlBackend}api/v1/user-profiles/?${queryParams}`,
    true
  );
};




// export const updateSystemGroupPermissions = async ({
//   id,
//   data,
// }: UpdateUserProfileParams) => {
//   const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
//   setIsGlobalLoading(true);

//   return put(`${urlBackend}api/v1/group/${id}/`, data, true);
// };